import Component from '../abstracts/Component';
import WishlistLogic from '../businessLogic/WishlistLogic';

export default class WishlistComponent extends Component {
  get SELECTORS() {
    return {
      headerIcon: '.action--wish',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      active: 'active'
    };
  }

  constructor() {
    super();
    this.headerIcon = $(this.SELECTORS.headerIcon);
  }

  updateWishlistIcons(e, status) {
    const wishlistWrapper = $(e.payload.elem).parents('[data-on-wish]');

    wishlistWrapper.attr('data-on-wish', `${status}`);
    if (e.payload.count > 0) this.headerIcon.attr('data-wishlist', true);
    else this.headerIcon.attr('data-wishlist', false);
  }

  showSizeLayer() {
    //TODO
  }

  showNotifyMe() {
    //TODO
  }

  bindEvents() {
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, (e) => {
      this.updateWishlistIcons(e, true);
    });
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      this.updateWishlistIcons(e, false);
    });

    //TODO
    // this.$on('click.showsize', (e) => {
    //   this.showSizeLayer(e);
    // });
  }

  render() {
    this.log('Rendering...');
    this.WishlistLogic = new WishlistLogic(this);
    this.WishlistLogic.render();
    this.bindEvents();
  }
}
